import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SystemUser } from 'src/app/model/user/system-user.model';
import { Account } from 'src/app/model/user/account';

@Injectable({ providedIn: 'root' })
export class ManageAccountSoService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        })
    };
    version = 'v1.0';
    url = environment.apiUrl + this.version + '/DisDepartmentUsers';
    constructor(private http: HttpClient) {
    }
    getSystemUsers(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/Get?' + queryString);
    }
    getSystemUsersById(id: any): Observable<any> {
        return this.http.get(this.url + `/GetById/${id}`, this.httpOptions);
    }

    getSystemUsersSelectPaging(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetSelectPaging?' + queryString);
    }

    getGetDisEducationAndTrainingFor(filter: any): Observable<any> {
        // let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetDisEducationAndTrainingFor');
    }
    addOrUpdateSystemUsers(SystemUsers: SystemUser): Observable<any> {
        if (SystemUsers.id == 0 || SystemUsers.id == undefined) {
            return this.http.post(this.url + '/Add', SystemUsers, this.httpOptions);
        } else {
            return this.http.put(this.url + `/Update/${SystemUsers.id}`, SystemUsers, this.httpOptions);
        }
    }
    updateSystemUsers(account: Account): Observable<any> { 
            return this.http.put(this.url + `/Update/${account.id}`, account, this.httpOptions); 
    }
    deleteSystemUsers(id: number): Observable<any> {
        return this.http.delete(this.url + `/Delete/${id}`, this.httpOptions);
    }
    deleteMulti(listId: number[]): Observable<any> {
        return this.http.post(this.url + `/DeleteMulti`, listId, this.httpOptions);
    }
    // deleteMultiDecentralization(listId: number[]): Observable<any> {
    //     return this.http.post(this.url + `/DeleteMultiDecentralization`, listId, this.httpOptions);
    // }
    addMultiple(model): Observable<any> {
        return this.http.post(this.url + '/AddMultiple', model, this.httpOptions);
    }

    updateMultiple(model): Observable<any> {
        return this.http.put(this.url + '/UpdateMultiple', model, this.httpOptions);
    }
    // updateMultipleQuyen(model): Observable<any> {
    //     return this.http.put(this.url + `/UpdateDecentralization`, model, this.httpOptions);
    // }


    updateMultiplePassword(model): Observable<any> {
        return this.http.put(this.url + '/UpdateMultiplePassword', model, this.httpOptions);
    }

    // get thong tin don vi: So, phong, truong
    getUserEducationAndTrainingOrSchool(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetUserEducationAndTrainingOrSchool?' + queryString);
    }

    changePassword(user: any): Observable<any> {
        return this.http.post(this.url + `/ChangePassword`,user,this.httpOptions);
    }
    exportExcel(filter: any): Observable<any> {
        filter = JSON.parse(JSON.stringify(filter));
        delete filter.PageIndex; delete filter.PageSize; 
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetSelectPagingExport?' + queryString, { responseType: 'blob' as 'json' });
    }

}
